import registry from 'rlink-repos/registry';
import {Article, Author} from 'rlink-blog';
import {ShopItem} from 'rlink-shop';
import {TwitchConfig} from 'rlink-twitch';
import {
  ArticlesIndexer,
  ArticleBySlug,
  MediaIndexer,
  FactionSettingsIndexer,
  FactionSettingsByFaction,
  ShopIndexer,
  ShopItemBySlug,
} from './indexers';

import {StructuredDataContent} from 'rlink-repos/content';

class MediaItem extends StructuredDataContent {
  static get contentIcon () {
    return 'picture-o';
  }

  get category () {
    return this.data.get('category');
  }

  get title () {
    return this.data.get('title', '');
  }

  get slug () {
    return this.data.get('slug', '');
  }

  get thumbnailPath () {
    return this.data.get('thumbnailPath');
  }

  get ytid () {
    return this.data.get('ytid');
  }

  get devices () {
    return this.data.get('devices', {});
  }

  get priority () {
    return this.data.get('priority', 0);
  }

  get row () {
    return this.data.get('row', 0);
  }

  get adminLabel () {
    return `${this.category || '[???]'} ${this.title}` && this.title.length > 0 ? this.title : '<untitled media item>';
  }
  get linkedContentPaths () {
    let paths = [];
    if (this.thumbnailPath) {
      paths.push(this.thumbnailPath);
    }
    for (let device of this.devices) {
      for (let res of device) {
        let imagePath = res.get ? res.get('imagePath') : res.imagePath;
        if (imagePath) {
          paths.push(imagePath);
        }
      }
    }

    return paths;
  }

  static defaultData () {
    return {
      devices: { desktop: [], tablet: [], mobile: []},
    };
  }
}

MediaItem.translatedAttributes = {
  title: {
    path: ['title'],
    description: 'Media gallery item caption.',
  },
};

class FactionSettings extends StructuredDataContent {
  static get contentIcon () {
    return 'id-card-o';
  }

   imageFormats () {
    return this.imageCarousel.map(img => Object.assign(img, {
      src: img.imagePath,
    }));
  }
  get factionId () {
    return this.data.get('factionId', '');
  }

  get abilities () {
    return this.data.get('abilities', []);
  }

  get unitReveals () {
    return this.data.get('unitReveals', []);
  }

  get imageCarousel () {
    return this.data.get('imageCarousel', [])
      .map(img => Object.assign(img.toJS(), {
        formats: [
          {contentType: 'image/webp', fileExt: 'webp'},
          {contentType: 'image/jpeg', fileExt: 'jpg'},
        ],
        src: img.get('imagePath', img.get('src')),
        widths: [
          2560, 1920, 1680, 1366, 1024, 800, 568, 480, 420, 320,
        ],
      }));
  }

  get adminLabel () {
    return `${this.category || '[???]'} ${this.factionId}` && this.factionId.length > 0 ? this.factionId : '<untitled faction dataset>';
  }

  get linkedContentPaths () {
    return super.linkedContentPaths.concat(this.unitReveals.map(img => img.get('imagePath')).toJS());
  }

  static defaultData () {
    return {
      factionId: '',
      abilities: [],
      unitReveals: [],
      imageCarousel: [],
    };
  }
}

FactionSettings.translatedAttributes = {
  abilityTitle: {
    path: ['abilities'],
    values: ['title'],
    keys: ['mediaName'],
    description: 'The name of a hero unit\'s special ability',
  },
  abilityDescription: {
    path: ['abilities'],
    values: ['description'],
    keys: ['mediaName'],
    description: 'Full paragraph description of a hero unit\'s special ability',
  },
  unitRevealTitle: {
    path: ['unitReveals'],
    values: ['title'],
    keys: ['articleSlug'],
    description: 'The name of an in-game unit.',
  },
  imageTitle: {
    path: ['imageCarousel'],
    values: ['title'],
    keys: ['imagePath'],
    description: 'An image caption.',
  },
};

class GlobalSettings extends StructuredDataContent {
  static get contentIcon () {
    return 'globe';
  }

  get adminLabel () {
    return 'Global Settings';
  }

  static get isAdministrative () {
    return true;
  }
  static get path () {
    return '/content/global-settings.json';
  }

  get defaultRatingsBoard () {
    return this.data.get('defaultRatingsBoard', '');
  }

  get footerRatingsBoards () {
    return this.data.get('footerRatingsBoards', {});
  }

  get linkedContentPaths () {
    if (Object.values(this.footerRatingsBoards).length === 0) {
      return [];
    }

    return Object.values(this.footerRatingsBoards.toJS()).map(imageLinks => (
      imageLinks.map(img => (img.imagePath))
    )).reduce((a, b) => (a.concat(b)));

  }

  static get (repo) {
    return this.fetchOrMakeFromPath(repo, this.path, {
      defaultRatingsBoard: 'pegi',
      footerRatingsBoards: {},
    });
  }

}

export default registry({
  Article,
  ArticlesIndexer,
  Author,
  ArticleBySlug,
  MediaItem,
  MediaIndexer,
  FactionSettings,
  FactionSettingsIndexer,
  FactionSettingsByFaction,
  GlobalSettings,
  ShopIndexer,
  ShopItem,
  ShopItemBySlug,
  TwitchConfig,
});





// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/content.js